<template>
  <section class="section--comp">
    <div class="container items-center lg:w-4/5">
      <h3 class="section--h3 mb-base">Connect</h3>
      <p class="section-p mb-base">
        ALEX comes as an Add-on for GetBoarded Competency Mapping platform that
        identifies the current skills of the learner and thus provides the
        Training Need Identification base to deploy ALEX framework for
        Micro-Learning and Distributed Trainings. Even though it comes as a
        complete solution it is modular enough to plug and play within your
        existing tools.
      </p>
      <img src="@/assets/images/demo/Editor.svg" class="mb-base hidden lg:block" width="100%" />
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">1</div>
          </div>
          Connect a Competency Development Model
        </div>
        <div class="alex-content p-4 items-left">
          <p>
            In the past days of open MOOCs companies provided free and
            unrestricted access to trainings. Recognizing the need for training
            is easy, but knowing what to do and how to do it is the harder part.
            Imagine someone you know perceives a problem and thinks training
            might resolve it. For example, maybe a manager says that her sales
            rep needs to be more efficient. Before jumping into building the
            training, it’s always a good idea to take a step back and assess the
            situation. That’s what a competency development model is for. How to
            choose what competencies to build in an Organization?
          </p>
        </div>
      </vs-card>
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">2</div>
          </div>
          Connect your Talent to the Initiative
        </div>
        <div class="alex-content p-4 items-left">
          <p>
            Time and Data are the new age currencies. We now live in a world
            that expects instant gratification of their effort. So we make the
            development process rewarding at every step. As the users connect to
            the platform to enter their current competencies we reward them with
            a beautifully designed infographic resume. Their attention to this
            process is a rewarding experience of a tangible output. While they
            engage in our career lab to assess their hidden strengths and blind
            spots, we understand their learning needs and development priorities
            to quantify the 4 drivers of learning.
          </p>
        </div>
      </vs-card>
      <vs-card class="w-full mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">3</div>
          </div>
          Collect consent and preferences with love
        </div>
        <div class="alex-content p-4 items-left">
          <p>
            In the age of 'likes' and 'hearts', the digital world now expects
            instant gratification. We cannot get people to engage in initiative
            if it is forced top-down. In order to take the attention you have to
            give value back in return, thus we have an intuitive infographic
            editor as an interface that gives learners an result oriented
            experience. Learner is always working on his development, not just
            filling forms. The whole experience is centred around measurable
            output, rewards and goals.
          </p>
        </div>
      </vs-card>
    </div>
  </section>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
section {
  padding-top: 10rem;
}
.section-p {
  font-size: 1.25rem;
  color: #848199;
}
.con-vs-card >>> .vs-card--content {
  padding: 0 !important;
}
.con-vs-card {
  border-radius: 20px;
}

.alex-title {
  background: rgba(220, 0, 50, 0.1);
  border-radius: 12px 12px 0px 0px;
  font-style: normal;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 20px;
  line-height: 24px;
  color: #dc0032;
}

.alex-content p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #848199;
}
.number-bullet {
  background: #dc0032;
  box-shadow: 0px 4px 12px rgba(220, 0, 50, 0.25);
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;
}
@media (max-width: 1200px) {
  section {
    padding: 5rem 0;
  }
}
</style>
